module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE STARTING LIE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Since my time machine didn’t work, I was forced to go to school today, and here’s what happened. After lunch we had a school assembly. The speaker was a Temon city worker with poofy hair. He came to talk to us about his job working at the city parks. He talked a lot about watering things. He went on and on about how challenging his work was and then he said … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2A_fmt.jpeg",
      "width": "316"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t want to laugh, but I couldn’t help it—words like "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("duty")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("pooped")]), _vm._v(" are immaturity power words. The second I laughed, the whole crowd began to laugh with me. It took Principal Smelt ten minutes to get everyone calmed down, and Mr. Poofy Hair stormed off the stage in a huff. I shouldn’t have laughed, but city workers need to be careful about what they say in front of middle schoolers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was raised not to joke about gross things. When I was really little, my mom made me watch "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Adventures of Bathroom Billy.")]), _vm._v(" It’s an educational show about a talking toilet named Billy that helps kids know how to properly act in the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2B_fmt1.jpeg",
      "width": "431"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I had failed Bathroom Billy, and my laughing had ruined the whole assembly. The speaker was mad, the teachers were mad, and lots of the students were mad because we had to go back to our classes. Principal Smelt was so upset his ears were steaming. As I was walking out of the assembly, he stopped me in the hall to ask me if I had anything to do with what he was calling … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "250",
      "src": "images/2C_fmt.jpeg",
      "width": "396"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Principal Smelt was angrier than I had ever seen him before. His face was red, and his mustache looked sweaty. He wanted me to name names. He wanted me to tell him everyone I had seen laughing. He also informed me that the city worker with the poofy hair was actually his second cousin.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2D_fmt.jpeg",
      "width": "418"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I felt bad, but I also felt like I should keep my mouth shut. I didn’t see how it would help for me to speak up and let him know it was my fault. Principal Smelt wiped his forehead and asked,")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2E_fmt.jpeg",
      "width": "351"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Okay, this is the spot where I need to remind you that I’ve already apologized. I shouldn’t have laughed at what my principal’s second cousin had said, but I especially shouldn’t have opened my mouth and lied about it.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2F_fmt.jpeg",
      "width": "284"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Principal Smelt stared at my swelling nose for a moment. He sighed louder than anyone I had ever heard sigh before and then smiled weakly. He patted me on the shoulder and called me a good egg.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2G_fmt.jpeg",
      "width": "288"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Principal Smelt concluded our conversation by informing me that he needed to find and punish the students who laughed first. He assigned me to do some “sleuthing” and discover who the “instigator” was. I said okay, even though I didn’t completely understand what he was asking.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So, after dinner tonight, I looked up the word "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("instigator")]), _vm._v(" in my mom’s old dictionary. According to the definition, I was one. I had instigated the laughing, and I followed that laughing by lying. Principal Smelt was wrong—I was a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("bad")]), _vm._v(" egg.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "240",
      "src": "images/2H_fmt1.jpeg",
      "width": "333"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I sat down on my bed and stared at my closet door. Beardy, the little face on my brass closet doorknob, looked like he was disappointed in me.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2I_fmt.jpeg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Beardy made me think of Wonkenstein and Hairy. I missed the first two creatures that had come out of my closet. It’d be great to have them here now so that I could explain myself to somebody.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2J_fmt.jpeg",
      "width": "519"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Wonk and Hairy had made my life pretty crazy, but they had been fun to have around. Not a day went by when I didn’t wish they’d at least return for a visit. I’ve tried to get back into my closet to see if anyone else might be in there, but Beardy keeps it locked tight.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2K_fmt.jpeg",
      "width": "203"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I wanted to lie down on my bed and rest, but the word "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("lie")]), _vm._v(" made me uncomfortable. I opened my bedroom window to climb out and go see my friends. As I was climbing out, I heard a scratching noise coming from behind my closet door. I spun around. My closet gurgled and burped loudly. Light began to seep out from beneath the door. To make things more unsettling, Beardy was shining.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2L_fmt.jpeg",
      "width": "401"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I reached out to turn Beardy. He was locked and hot, causing me to yelp. I stepped back and stared at my closet door. My insides tumbled and turned like grapes in a washing machine.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2M_fmt.jpeg",
      "width": "221"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My closet made a large noise as something shifted and moved behind the door. My poor stomach felt beat up.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2O_fmt.jpeg",
      "width": "430"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I stared at my closet and waited for the door to pop open. I tested Beardy, but he was being stubborn and refused to budge.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2N_fmt.jpeg",
      "width": "223"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The glowing stopped, and eventually my closet door looked normal again. It was only seven o’clock, but I was tired. I had gone to bed late last night because my nose still hurt and I couldn’t get comfortable in my bed. So I had stayed up and watched a movie. The one I saw was about a spy who had the ability to pop his eyes out and use them to spy on people from far away. It was called … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/2P_fmt.jpeg",
      "width": "482"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The eyes were able to bounce and do all kinds of freaky things like see through walls and make little bruises on people by pelting them. In one of the scenes, there was a guy combing his hair in a bathroom and one of the eyes was spying on him from inside his tube of toothpaste. When he went to brush his teeth, the eye squeezed out and attacked the man.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "270",
      "src": "images/2Q_fmt.jpeg",
      "width": "562"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was a pretty stupid movie, but after watching I was scared to brush my teeth and go to bed. I was worried that some eyes might bounce up on me. Tonight, however, I was so tired I didn’t care if someone’s entire face was after me. I told my family to leave me alone, changed into one of my dad’s old concert T-shirts, and climbed into bed. I pulled out the Thumb Buddies comic book I kept hidden under my mattress and read two quick pages.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "400",
      "src": "images/2R_fmt.jpeg",
      "width": "487"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I wanted to find out what happened to Baby Stabs, but I fell asleep. I woke up five hours later at midnight. My room was pitch black, and the house was quiet. I could hear my fat dog, Puck, snoring softly down the hall. My bladder was whining about being full.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2S_fmt1.jpeg",
      "width": "385"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was not going to get up and go to the bathroom. Not with stray eyeballs bouncing around. I closed my eyes, and as I was trying to drift back to sleep, I heard a soft … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "50",
      "src": "images/2T2_fmt.jpeg",
      "width": "228"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My eyelids snapped open. I turned my head from side to side, wondering if there was a stray eyeball bouncing toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "80",
      "src": "images/2T_fmt1.jpeg",
      "width": "310"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The noise sounded like something wooden climbing up onto my bed. My heart went into overdrive as the noise got louder.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "150",
      "src": "images/2T_fmt.jpeg",
      "width": "549"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I felt something cold brush over my face. Quickly I reached to the side of my bed and grabbed my baseball bat. There was a loud crunching noise as I stood up and flipped on my desk light. I had grabbed the bat to swing at the intruder, but that was no longer necessary. The intruder had beat me to it.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2U_fmt.jpeg",
      "width": "441"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hanging from the end of my wooden bat was a brand-new visitor. I couldn’t decide if I should scream or smile. My closet had done it again. I noticed the closet door was now open about an inch and Beardy looked smug.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "200",
      "src": "images/2V_fmt.jpeg",
      "width": "202"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Holding the bat, with the creature still dangling, I moved over and softly closed my bedroom door. The last thing I wanted to do was wake my parents. I was nervous, but I was also happy to see that my closet had produced something new.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The little guy’s teeth were stuck in the wood, and he was having a difficult time getting them loose. I swung the bat gently, and he broke free. He fell off the bat, and I slipped backward onto my purple beanbag. The creature smiled at me. I should let you know that it was a far more mischievous smile than Wonk or Hairy had ever smiled. I looked at the creature to determine what books had helped shape him. He had a partial cape and jet-black hair. One arm and leg looked like they were made from wood, and his nose was pointy and long. He had on a small, tapered hat, and there were strings hanging from his left arm. He looked like a vampire that was closely related to the Pinocchio family.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/2W_fmt.jpeg",
      "width": "466"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I set him on my desk so that I could study him better.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2X_fmt.jpeg",
      "width": "466"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I think I was about to say something important when a black object flew out of my closet and brushed the back of my head. My heart went nuts.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "170",
      "src": "images/2Y_fmt.jpeg",
      "width": "219"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I turned around and frantically searched the room for what had assaulted me. A small shadow darted across my view and into the corner behind my beanbag.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "270",
      "src": "images/2Z_fmt.jpeg",
      "width": "453"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Pinocula wasn’t spilling the beans. Whatever it was darted back up, flew over my head, and smacked against the window. I grabbed my pillow and slipped off the case. Holding it like a net, I dove toward the flying intruder.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/2Za_fmt1.jpeg",
      "width": "504"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The fluttering dark spot zigged and I missed. I slid up against my closet door with a thud as whatever it was flapped madly above me. I tried to grab it, but all I saw was a cloud of wings and my hands. As I was swatting it away, it bit me on the right thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "280",
      "src": "images/2Zb_fmt.jpeg",
      "width": "427"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Pinocula whistled softly, and the flying object darted away from me. It hovered in the air a few feet to the side of Pinocula and flapped its wings. I stood up and with one swoop bagged the flying menace in my pillowcase. It thrashed and jiggled. The sack kept smacking up against me as I tried to hold it closed.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "280",
      "src": "images/2Zc_fmt.jpeg",
      "width": "350"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I had no idea what to do. To make matters worse, my dad suddenly knocked on my bedroom door.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/2Zd_fmt.jpeg",
      "width": "365"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was far from all right, and unless I moved quickly, I was about to be in big trouble.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 72
// module chunks = 0